export const getReadablePlanName = (planName: string) =>
  planName.toLowerCase().includes('борс') ? 'Борсов' : 'Фиксиран';
